module.exports = __webpack_public_path__ + "img/Gallery_1_19.140f5dd8.jpeg";